import { Stack } from 'expo-router';

export default function TrailLayout() {
  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen name="index" options={{ animation: 'fade' }} />
      <Stack.Screen name="category/[slug]" options={{ animation: 'slide_from_right' }} />
      <Stack.Screen name="[slug]" options={{ animation: 'slide_from_right' }} />
    </Stack>
  );
}
